import * as React from 'react';
import cx from 'classnames';
const styles = require('./index.less');

export const TEMPLATE_TYPE = {
  LEFT: 'left',
  CENTER: 'mid',
  RIGHT: 'right'
};

// MainSlot 和 FunctionSlot 作为标识组件
export const SloganSlot = ({ children }) => children;
export const FunctionSlot = ({ children }) => children;

const TemplateBox = ({ type = TEMPLATE_TYPE.LEFT, children } = {}) => {
  let sloganContent = <React.Fragment />;
  let functionContent = <React.Fragment />;

  React.Children.forEach(children, child => {
    if (React.isValidElement(child)) {
      if (child.type === SloganSlot) {
        sloganContent = child.props.children;
      } else if (child.type === FunctionSlot) {
        functionContent = child.props.children;
      }
    }
  });

  const LeftType = () => {
    return (
      <div className={cx(styles.templateBox, styles.leftType)}>
        <div className={styles.box_l}>
          <div className={cx(styles.box_l_t, styles.sloganSlot)}>{sloganContent}</div>
          <div className={cx(styles.box_l_b, styles.functionSlot)}> {functionContent}</div>
        </div>
        <div className={styles.box_r} />
      </div>
    );
  };

  const CenterType = () => {
    return (
      <div className={cx(styles.templateBox, styles.centerType)}>
        <div className={styles.box_center}>
          <div className={cx(styles.box_center_t, styles.sloganSlot)}>{sloganContent}</div>
          <div className={cx(styles.box_center_b, styles.functionSlot)}>{functionContent}</div>
        </div>
      </div>
    );
  };

  const RightType = () => {
    return (
      <div className={cx(styles.templateBox, styles.rightType)}>
        <div className={styles.box_l} />
        <div className={styles.box_r}>
          <div className={cx(styles.box_r_t, styles.sloganSlot)}>{sloganContent}</div>
          <div className={cx(styles.box_r_b, styles.functionSlot)}>{functionContent}</div>
        </div>
      </div>
    );
  };

  switch (type) {
    case TEMPLATE_TYPE.CENTER: {
      return <CenterType />;
    }
    case TEMPLATE_TYPE.RIGHT: {
      return <RightType />;
    }
    default: {
      return <LeftType />;
    }
  }
};

export default TemplateBox;
